module.exports = __webpack_public_path__ + "assets/images/sync-big1.f04d95ed.png";